import { TNewbuildingBrokerCallbackWidgetClickType } from 'shared/types/newbuildingBrokerOfferBooking';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingBrokerOfferBookingActions {
  SetEnabled = 'newbuildingBrokerOfferBooking/setEnabled',
  OpenCallbackWidget = 'newbuildingBrokerOfferBooking/openCallbackWidget',
  CloseCallbackWidget = 'newbuildingBrokerOfferBooking/closeCallbackWidget',
}

export const setNewbuildingBrokerOfferBookingEnabled = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.SetEnabled,
  boolean
>(ENewbuildingBrokerOfferBookingActions.SetEnabled);

export const openNewbuildingBrokerCallbackWidget = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget,
  TNewbuildingBrokerCallbackWidgetClickType
>(ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget);

export const closeNewbuildingBrokerCallbackWidget =
  actionGenerator<ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget>(
    ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget,
  );

export type TNewbuildingBrokerOfferBookingActions =
  | ReturnType<typeof setNewbuildingBrokerOfferBookingEnabled>
  | ReturnType<typeof openNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof closeNewbuildingBrokerCallbackWidget>;
